angular.module('app.myProfile.transactionHistory.transactionHistoryService', [])
  .factory('transactionHistoryService', [
    '$http',
    function ($http) {
      "use strict";

      let service = {
        list: null,
        error: null,
        retrieve: function () {
          return $http.get(window.location.api('my_account/data/transactions'))
            .then(function (response) {
              let data = response.data;

              service.error = null;
              if (data.error) {
                service.error = data.error;
              }
              else if (data.transactions) {
                service.list = data.transactions;
              }
              else {
                service.error = 'Failed to retrieve transaction history.';
              }
            })
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/myProfile/transactionHistory/transactionHistoryService.js